import { render, staticRenderFns } from "./AlarmDefinitionsTable.vue?vue&type=template&id=b956638c&scoped=true"
import script from "./AlarmDefinitionsTable.vue?vue&type=script&lang=ts"
export * from "./AlarmDefinitionsTable.vue?vue&type=script&lang=ts"
import style0 from "./AlarmDefinitionsTable.vue?vue&type=style&index=0&id=b956638c&prod&lang=scss&scoped=true"
import style1 from "./AlarmDefinitionsTable.vue?vue&type=style&index=1&id=b956638c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.99.8__lodash@4.17.21_prettier@2.8.8_vue-_69bc0556815cefdff9c73fe5644cf446/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b956638c",
  null
  
)

export default component.exports